import { Link } from "react-router-dom";
import "../css/about.css";

export function AboutComponent() {
    return (
        <div className="about-container">
            <h1>About Pirate Scrabble</h1>
            
            <section className="about-section">
               <h2>How to Play</h2>
               <div className="info-box">
                  <p>
                     New to the game? Check out our <Link to="/rules" className="about-link">Rules</Link> page.
                  </p>
               </div>
            </section>

            <section className="about-section">
                <h2>Credits</h2>
                <p>
                    This digital version of Pirate Scrabble was built by Jerome and Benson 
                    using React and Ktor.
                </p>
                <p>
                    Special thanks to our friend Tiffany for introducing Pirate Scrabble to us!
                </p>
            </section>
        </div>
    );
}
